export const createArrayOfLength = <T>(length: number, value?: T): T[] =>
    length > 0 ? Array(length).fill(value) : [];
